module.exports = __webpack_public_path__ + "static/media/online-deposit.01c2c14b.svg";